var header;
jQuery(document).ready(function(){
    header = jQuery('header');
    if(!header.length) return;
    header.find('.menu-toggler').click(function(){header.toggleClass('active')});
    if(jQuery("body.single-projet").length){
        jQuery(window).resize(checkHeaderGap);
        checkHeaderGap();
    }
});

function checkHeaderGap(){
    header.next().css('padding-top', Math.ceil(header.outerHeight()));
}